<template>
    <van-popup v-model="show" closeable round :close-on-click-overlay="true" position="bottom" :style="{ height: '650px', overflow: 'hidden' }">
      <div class="popup-container">
        <!-- 内容区域，flex:1 撑满 -->
        <div class="popup-content">
          <div class="popup-title">用户协议</div>
          <div class="statement">
            <p style="text-indent: 2em; ">请您阅读并选择接受或者不接受本《协议》。除非您接受本《协议》所有条款,否则您无权注册、登录或者使用“本软件”所提供的相关服务。您的使用行为将视为对本《协议》的接受，并同意接受本《协议》的各项条款约束。</p>
            <p style="font-weight: bold;">一. 使用规则</p>
            <ol>
              <li style="text-indent: 2em; ">1.您充分了解并同意，本软件是仅为您提供信息分享、传送及获取的平台，您必须为自己的一切行为负责，包括您所传送的任务内容以及由此产生的任何后果。您应对本软件中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确时、完成性或实用性的依赖而产生的风险。本软件无法且不会对因用户行为而导致的任何损失或损害承担责任。</li>
              <li style="text-indent: 2em; ">2.您在本软件服务中或者通过本软件所传送的任何内容并不违反本软件的观点或政策，本软件公司对此不承担任何责任。您须对本软件上所传送信息的真实性、合法性、无害性、有效性等全权负责，与您所传播的信息相关的任何法律责任由您自行承担，与本软件无关。</li>
              <li style="text-indent: 2em; ">3.您充分了解并同意，您在本软件应用上发布的任何公开信息具有使用权。适用范围包括，本软件应用内以及应用外其他法律允许的范围和区域。</li>
              <li style="text-indent: 2em; ">4.本软件提供服务时，根据使用服务的具体功能，可能需要手机部分设备信息，比如手机存储、摄像头等相关信息，本软件采用领先的安全防护措施，保护用户的个人信息。关于用户个人信息保护，依照《隐私政策协议》约定履行。</li>
              <li style="text-indent: 2em; ">5.本软件保留在任何时候通过您提供本“软件”替换、修改、升级版本的权利以及为替换、修改或升级收取费用的权利。</li>
              <li style="text-indent: 2em; ">6.用户权利及义务：
                <ol>
                  <li>（1）用户有权利获取本软件平台的信息服务、推送提醒以及本软件平台提供的其他服务；</li>
                  <li>（2）用户有权利通过邮件或者产品评论提出意见，但是评论内容的真实性、合法性由用户自行负责；</li>
                  <li>（3）用户因第三方如电信部分的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其它各种不可抗力原因而遭受的一切损失，本软件不承担责任。因技术故障不可抗力事件影响服务的正常运行的，本软件会及时处理进行修复，但用户因此承受的一切损失，本软件不承担责任。</li>
                </ol>
              </li>
            </ol>
            <p style="font-weight: bold;">二. 免责声明</p>
            <ol>
              <li style="text-indent: 2em; ">1.本服务仅用于辅助医疗诊断和治疗，不应视为专业医疗建议，用户应在任何医疗决策之前咨询专业医疗人员。</li>
              <li style="text-indent: 2em; ">2.服务提供的三维重建结果可能受到输入数据的质量和完整性的影响，我们不对因输入数据不完整或不准确而导致的任何错误或遗漏承担责任。</li>
              <li style="text-indent: 2em; ">3.本服务提供的结果仅供医疗专业人员参考，不得用于自我诊断或用于未经专业医疗人员确认的医疗决策。</li>
              <li style="text-indent: 2em; ">4.服务提供者不对因用户不当使用或解释三维重建结果而导致的任何损失或损害承担责任。</li>
              <li style="text-indent: 2em; ">5.服务提供者对用户使用本服务可能导致的任何直接、间接、附带或特殊损失不承担责任，包括但不限于财产损失、利润损失、业务中断等。</li>
              <li style="text-indent: 2em; ">6.本免责声明适用于服务的所有用户，使用本服务即视为接受本免责声明的约束。</li>
              <li style="text-indent: 2em; ">7.本软件服务和大多数互联网软件服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其他软件或访问的其他网站中含有的病毒，威胁到用户的计算机信息和数据的安全，继而影响本软件的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭受损失和骚扰。</li>
              <li style="text-indent: 2em; ">8.在任何情况下，本软件均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用本软件服务而遭受的利润损失承担责任。</li>
              <li style="text-indent: 2em; ">9.就下列相关事宜的发生，本软件不承担任何法律责任：
                <ol>
                  <li>（1）根据法律规定或相关政府的要求提供您的个人信息；</li>
                  <li>（2）任何第三方根据本软件各服务条款及声明中所列的情况使用您的个人信息，由此所产生的纠纷；</li>
                  <li>（3）任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性网站关闭；</li>
                  <li>（4）因不可抗力导致的任何后果。</li>
                </ol>
              </li>
            </ol>
            <p style="font-weight: bold;">三.法律适用及争议解决</p>
            <p style="text-indent: 2em; ">本用户协议的订立、执行、解释及争议的解决均应适用中华人民共和国法律。因本用户协议引起的或与本用户一些有关的任何争议，各方应友好协商解决。</p>
            <p style="font-weight: bold;">四. 协议变更与修订</p>
            <p style="text-indent: 2em; ">本软件更新相应条款后，用户可重新下载安装本软件查阅最新协议条款。修改《协议》条款后，如果用户不接受修改后的条款，请立即停止使用此软件和服务，用户继续使用将被视为已接收修改后的协议。</p>
          </div>
          <!-- <div class="bts-bottom" >
            <van-row gutter="20">
                <van-col span="12" >
                  <van-button round block @click="doCancel"  >返回</van-button>
                </van-col>
                <van-col span="12">
                  <van-button round block type="danger" @click="doConfirm"  >确认</van-button>
                </van-col>
            </van-row>
          </div> -->
        </div>
        <!-- 按钮区域，固定在底部 -->
        <div class="popup-footer">
          <van-button block @click="doCancel" >返回</van-button>
        </div>
      </div>
    </van-popup>
</template>

<script>
import { Popup, Row, Col, Button} from 'vant';
export default {
  components: {
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data() {
    return {
        show: false,
        loading: false,
        orderId: '',
        payAmount: 0,
        payAmountFmts: [],
        payStatus: -1,
        payResult: ''
    };
  },
  methods: {
    open(){
        this.show = true
    },
    doConfirm(){
      this.show = false
      this.$emit('confirm')
    },
    doCancel(){
      this.show = false
      this.$emit('cancel')
    }
  }
};
</script>
<style lang="less" scoped>
  .statement {
    margin: 20px 30px;
    li {
      padding-bottom: 10px;
    }
  }

  .popup-container {
    display: flex;
    flex-direction: column;
    height: 100%; /* 必须设置高度，配合父容器的固定高度 */
  }
  .popup-content {
    flex: 1;
    overflow-y: auto; /* 内容过多时允许滚动，防止撑开父容器 */
    // padding: 16px;
  }
  .popup-footer {
    padding: 8px;
    /* 如果你想要按钮有阴影或背景色，可以在这里添加 */
    background-color: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05); /* 可选的上方阴影 */
  }
</style>
